import {
  loginShopifyAppProxy,
  getSubscription as rechargeGetSubscription,
  listSubscriptions,
} from "@rechargeapps/storefront-client";

export async function getSubscription(subscriptionId) {
  const session = await loginShopifyAppProxy();
  return await rechargeGetSubscription(session, subscriptionId);
}

export async function getSubscriptions() {
  const session = await loginShopifyAppProxy();
  const subscriptionsData = await listSubscriptions(session);

  return subscriptionsData?.subscriptions ?? [];
}

export function getSlotNode(slotName) {
  return document.querySelector(`[data-testid='slot-${slotName}']`);
}
